import {MyDialogDataModel} from '../../models/my-dialog-data.model';
import {EditModalService} from '../../services/edit-modal.service';
import {Directive, OnInit} from '@angular/core';
import {ProjectUpdateNotificationFieldEnum} from '../../enums/project-update-notification-field.enum';
import {NgModel} from '@angular/forms';
import {timeout} from 'rxjs/operators';
import {IndustrySectorEnum} from '../../enums/industry-sector.enum';

@Directive()
// tslint:disable-next-line:directive-class-suffix  // remove this tslint command after angular update to 10
export abstract class EditModalSectionBaseComponent implements OnInit {

    public model: MyDialogDataModel;
    public pUNFEnum = ProjectUpdateNotificationFieldEnum;

    protected constructor(
        public editModalService: EditModalService
    ) {
    }

    ngOnInit(): void {
        this.model = this.editModalService.getDialogModel();
    }


    public isInternalUser() {
        return false;
    }


    /**
     * Highlights a field if it has been changed against the approved project state.
     * Highlighting state is provided by the backend like a list of field Ids.
     */
    public notifyChange(fieldId: ProjectUpdateNotificationFieldEnum): boolean {
        return this.editModalService.showChangeNotification(fieldId);
    }

    public viewLog(valueToLog: any, id: string = '') {
        console.log('viewLog [' + id + ']: ', valueToLog);
    }

}
